import { DESKTOP_CARD_SIZE, MOBILE_CARD_SIZE } from './style';

export const getVisibleProductsCount = (width: number, isMobile: boolean) => {
  const cardWidth = isMobile ? MOBILE_CARD_SIZE : DESKTOP_CARD_SIZE;
  return Math.floor(width / cardWidth);
};
